<template>
  <div v-if="canActOnWorkExperience()" class="mt-2">
    <strong v-if="withTitle" class="mr-2">Actions:</strong>
    <a-tooltip>
      <template #title> Edit work experience information </template>
      <a-icon
        type="edit"
        class="action-default"
        @click="
          (e) => {
            $emit('show-edit-work-experience-modal');
            e.stopPropagation();
          }
        "
      />
    </a-tooltip>
    <a-divider type="vertical" />
    <a-tooltip>
      <template #title> Delete work experience </template>
      <a-icon
        type="delete"
        class="action-danger"
        @click="
          (e) => {
            $emit('show-delete-work-experience-modal');
            e.stopPropagation();
          }
        "
      />
    </a-tooltip>
  </div>
</template>

<script setup lang="ts">
import { BaseAclInterface, ProfileInterface } from "@/modules/authentication/types";
import { WorkExperienceInterface } from "../types";

// Props
const props = defineProps({
  workExperience: { type: Object as () => WorkExperienceInterface, default: undefined },
  profile: { type: Object as () => ProfileInterface, default: undefined },
  acl: { type: Object as () => BaseAclInterface, default: () => ({}) },
  withTitle: { type: Boolean, default: false },
});

// Component methods
const canActOnWorkExperience = (): boolean => {
  return (
    props.workExperience.user.id === props.profile.id ||
    props.acl.isAdmin ||
    props.acl.isCr ||
    props.acl.isFinancial
  );
};
</script>
